import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-ach-gray',
  templateUrl: './icon-ach-gray.component.html',
  styles: []
})
export class IconAchGrayComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
